import { render } from "./AgendaReq.vue?vue&type=template&id=25a33226&scoped=true"
import script from "./AgendaReq.vue?vue&type=script&lang=js"
export * from "./AgendaReq.vue?vue&type=script&lang=js"

import "./AgendaReq.vue?vue&type=style&index=0&id=25a33226&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a33226"]])

export default __exports__